import { combineReducers } from 'redux-immutable';
import { createForms } from 'react-redux-form/immutable';
import { messageReducer } from './messages/messageReducer';

import { volcanoEventDataReducer } from './volcanoes/event/data/volcanoEventDataReducer';
import { volcanoEventSearchModel } from '../components/view/hazards/volcanoes/events/search/volcanoEventSearchModel';
import { volcanoEventSearchPageReducer } from './volcanoes/event/search/volcanoEventSearchPageReducer';
import { volcanoEventSearchReducer } from './volcanoes/event/search/volcanoEventSearchReducer';
import { volcanoEventEditModel } from '../components/view/hazards/volcanoes/events/edit/volcanoEventEditModel';
import { volcanoEventInfoReducer } from './volcanoes/event/info/volcanoEventInfoReducer';
import { editVolcanoEventReducer } from './volcanoes/event/edit/volcanoEventEditReducer';

import { volcanoLocationSearchModel } from '../components/view/hazards/volcanoes/locations/search/volcanoLocationSearchModel';
import { volcanoLocationEditModel } from '../components/view/hazards/volcanoes/locations/edit/volcanoLocationEditModel';
import { volcanoLocationSearchReducer } from './volcanoes/location/search/volcanoLocationSearchReducer';
import { volcanoLocationDataReducer } from './volcanoes/location/data/volcanoLocationDataReducer';
import { volcanoLocationEditReducer } from './volcanoes/location/edit/volcanoLocationEditReducer';
import { volcanoLocationSearchPageReducer } from './volcanoes/location/search/volcanoLocationSearchPageReducer';

import { earthquakeSearchReducer } from './earthquakes/search/earthquakeSearchReducer';
import { earthquakeSearchPageReducer } from './earthquakes/search/earthquakeSearchPageReducer';
import { earthquakeSearchModel } from '../components/view/hazards/earthquakes/search/earthquakeSearchModel';
import { earthquakeDataReducer } from './earthquakes/data/earthquakeDataReducer';
import { earthquakeInfoReducer } from './earthquakes/info/earthquakeInfoReducer';
import { earthquakeEditModel } from '../components/view/hazards/earthquakes/edit/earthquakeEditModel';
import { editEarthquakeReducer } from './earthquakes/edit/earthquakeEditReducer';

import { tsunamiEventEditModel } from '../components/view/hazards/tsunamis/events/edit/tsunamiEventEditModel';
import { tsunamiEventInfoReducer } from './tsunamis/event/info/tsunamiEventInfoReducer';
import { tsunamiEventSearchReducer } from './tsunamis/event/search/tsunamiEventSearchReducer';
import { tsunamiEventSearchPageReducer } from './tsunamis/event/search/tsunamiEventSearchPageReducer';
import { tsunamiEventSearchModel } from '../components/view/hazards/tsunamis/events/search/tsunamiEventSearchModel';
import { tsunamiEventDataReducer } from './tsunamis/event/data/tsunamiEventDataReducer';
import { tsunamiRelatedRunupsDataReducer } from './tsunamis/event/related-runup/tsunamiRelatedRunupsReducer';
import { tsunamiRelatedDepositsReducer } from './tsunamis/event/related-deposit/tsunamiRelatedDepositsReducer';
import { editTsunamiEventReducer } from './tsunamis/event/edit/tsunamiEventEditReducer';

import { referenceSearchReducer } from './references/search/referenceSearchReducer';
import { referenceSearchModel } from '../components/view/reference/search/referenceSearchModel';
import { referenceDataReducer } from './references/data/referenceDataReducer';
import { referenceEditModel } from '../components/view/reference/edit/referenceEditModel';
import { editReferenceReducer } from './references/edit/referenceEditReducer';

import { runupSearchReducer } from './tsunamis/runups/search/runupSearchReducer';
import { runupSearchPageReducer } from './tsunamis/runups/search/runupSearchPageReducer';
import { runupSearchModel } from '../components/view/hazards/tsunamis/runups/search/runupSearchModel';
import { runupDataReducer } from './tsunamis/runups/data/runupDataReducer';
import { runupInfoReducer } from './tsunamis/runups/info/runupInfoReducer';
import { runupEditReducer } from './tsunamis/runups/edit/runupEditReducer';
import { runupEditModel } from '../components/view/hazards/tsunamis/runups/edit/runupEditModel';

import { depositSearchModel } from '../components/view/hazards/tsunamis/deposits/search/depositSearchModel';
import { depositSearchReducer } from './tsunamis/deposits/search/depositSearchReducer';
import { depositEditReducer } from './tsunamis/deposits/edit/depositEditReducer';
import { depositRelatedTsunamisReducer } from './tsunamis/deposits/related-tsunamis/depositRelatedTsunamisReducer';
import { depositEditModel } from '../components/view/hazards/tsunamis/deposits/edit/depositEditModel';

import { marigramSearchModel } from '../components/view/hazards/tsunamis/marigrams/search/marigramSearchModel';
import { marigramSearchReducer } from './tsunamis/marigrams/search/marigramSearchReducer';
import { marigramSearchPageReducer } from './tsunamis/marigrams/search/marigramSearchPageReducer';
import { marigramDataReducer } from './tsunamis/marigrams/data/marigramDataReducer';
import { marigramInfoReducer } from './tsunamis/marigrams/info/marigramInfoReducer';
import { marigramEditReducer } from './tsunamis/marigrams/edit/marigramEditReducer';
import { marigramEditModel } from '../components/view/hazards/tsunamis/marigrams/edit/marigramEditModel';

import { loginReducer } from './login/loginReducer';
import { effectsDescriptorReducer } from './effects/effectDescriptorReducer';
import { referenceInfoReducer } from './references/info/referenceInfoReducer';

const forms = {};

forms[volcanoLocationSearchModel.get('name')] = volcanoLocationSearchModel.get('initialValues');
forms[volcanoLocationEditModel.get('name')] = volcanoLocationEditModel.get('initialValues');

forms[volcanoEventSearchModel.get('name')] = volcanoEventSearchModel.get('initialValues');
forms[volcanoEventEditModel.get('name')] = volcanoEventEditModel.get('initialValues');

forms[earthquakeSearchModel.get('name')] = earthquakeSearchModel.get('initialValues');
forms[earthquakeEditModel.get('name')] = earthquakeEditModel.get('initialValues');

forms[tsunamiEventSearchModel.get('name')] = tsunamiEventSearchModel.get('initialValues');
forms[tsunamiEventEditModel.get('name')] = tsunamiEventEditModel.get('initialValues');

forms[runupSearchModel.get('name')] = runupSearchModel.get('initialValues');
forms[runupEditModel.get('name')] = runupEditModel.get('initialValues');

forms[depositSearchModel.get('name')] = depositSearchModel.get('initialValues');
forms[depositEditModel.get('name')] = depositEditModel.get('initialValues');

forms[marigramSearchModel.get('name')] = marigramSearchModel.get('initialValues');
forms[marigramEditModel.get('name')] = marigramSearchModel.get('initialValues');

forms[referenceSearchModel.get('name')] = referenceSearchModel.get('initialValues');
forms[referenceEditModel.get('name')] = referenceEditModel.get('initialValues');


export const rootReducer = combineReducers({
  ...createForms(forms),
  volcanoEventSearchPage: volcanoEventSearchPageReducer,
  volcanoEventSearch: volcanoEventSearchReducer,
  volcanoEventInfoPage: volcanoEventInfoReducer,
  volcanoEventEditPage: editVolcanoEventReducer,
  volcanoEventDataPage: volcanoEventDataReducer,

  volcanoLocationSearchPage: volcanoLocationSearchReducer,
  volcanoLocationDataPage: volcanoLocationDataReducer,
  volcanoLocationEditPage: volcanoLocationEditReducer,
  volcanoLocationSearchPageState: volcanoLocationSearchPageReducer,

  earthquakeSearchPage: earthquakeSearchReducer,
  earthquakeSearchPageState: earthquakeSearchPageReducer,
  earthquakeDataPage: earthquakeDataReducer,
  earthquakeInfoPage: earthquakeInfoReducer,
  earthquakeEditPage: editEarthquakeReducer,

  tsunamiEventSearchPage: tsunamiEventSearchReducer,
  tsunamiEventSearchPageState: tsunamiEventSearchPageReducer,
  tsunamiEventDataPage: tsunamiEventDataReducer,
  tsunamiEventInfoPage: tsunamiEventInfoReducer,
  tsunamiEventEditPage: editTsunamiEventReducer,
  tsunamiRelatedRunupsPage: tsunamiRelatedRunupsDataReducer,
  tsunamiRelatedDepositsPage: tsunamiRelatedDepositsReducer,

  referenceSearchPage: referenceSearchReducer,
  referenceDataPage: referenceDataReducer,
  referenceEditPage: editReferenceReducer,
  referenceInfoPage: referenceInfoReducer,

  runupSearchPage: runupSearchReducer,
  runupSearchPageState: runupSearchPageReducer,
  runupDataPage: runupDataReducer,
  runupInfoPage: runupInfoReducer,
  runupEditPage: runupEditReducer,

  marigramSearchPage: marigramSearchReducer,
  marigramSearchPageState: marigramSearchPageReducer,
  marigramDataPage: marigramDataReducer,
  marigramInfoPage: marigramInfoReducer,
  marigramEditPage: marigramEditReducer,

  depositSearchPage: depositSearchReducer,
  depositRelatedTsunamisPage: depositRelatedTsunamisReducer,
  depositEditPage: depositEditReducer,

  messages: messageReducer,
  loginPage: loginReducer,
  effectDescriptors: effectsDescriptorReducer,
});
